export default "__VITE_ASSET__4eb28524__"